import { DictType } from "@pma/types"
import { PrinterIcon } from "lucide-react"
import { useEffect, useState } from "react"
import printJS from "print-js"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/common/tooltip"
import { Button } from "@components/common/button"
import useTranslator from "@pma/hooks/use-translator"

type Props = {
  file: DictType
  isMenuView?: boolean
}
const printAble = ["jpg", "jpeg", "png", "pdf"]
const images = ["jpg", "jpeg", "png"]

export default function PrintFile({ file, isMenuView }: Props) {
  const { translate } = useTranslator()
  const [showPrintBtn, setShowPrintBtn] = useState(false)
  const [filetype, setFiletype] = useState(null)

  useEffect(() => {
    const fileType = file?.type
    if (fileType && printAble.includes(fileType)) {
      setFiletype(fileType)
      setShowPrintBtn(true)
    }
  }, [])

  const handleFilePrint = () => {
    if (filetype && images.includes(filetype)) {
      printJS({ printable: file.file, type: "image", showModal: true })
    } else if (filetype === "pdf") {
      printJS({ printable: file.file, type: "pdf", showModal: true })
    }
  }
  return showPrintBtn ? (
    isMenuView ? (
      <div className='flex items-center gap-2 rounded hover:bg-muted' onClick={handleFilePrint}>
        <div className='px-2'>
          <PrinterIcon className='' size={16} />
        </div>
        <span className='text-sm'>{translate("Print file")}</span>
      </div>
    ) : (
      <Tooltip>
        <TooltipTrigger>
          <Button
            variant={"ghost"}
            className='h-6 w-7 text-xs'
            size={"icon"}
            onClick={() => handleFilePrint()}
          >
            <PrinterIcon size={16} />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{translate("Print file")}</TooltipContent>
      </Tooltip>
    )
  ) : <></>
}
